import React, { useState, useEffect, useContext } from "react";
import {
  FaUser, FaEnvelope, FaShieldAlt, FaListAlt, FaBuilding
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import SubscriptionManager from "../components/SubscriptionManager";
import { AuthContext } from "../contexts/AuthContext";
import analytics from "../services/analytics";

const Profile = () => {
  const { isAuthenticated, checkTokenValidity } = useContext(AuthContext);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");

  useEffect(() => {
    // Check authentication immediately
    if (!isAuthenticated || !checkTokenValidity()) {
      navigate("/auth/signin");
      return;
    }

    const data = JSON.parse(localStorage.getItem("user_data") || sessionStorage.getItem("user_data"));
    setUser(data);
  }, [isAuthenticated, checkTokenValidity, navigate]);

  const renderRow = (icon, label, value) => (
    <div className="flex items-start gap-3 mb-3">
      <div className="text-blue-600 mt-1">{icon}</div>
      <div>
        <p className="text-sm font-semibold">{label}</p>
        <p className="text-sm text-gray-700">{value || ""}</p>
      </div>
    </div>
  );

  const renderTabButton = (id, label) => (
    <button
      key={id}
      onClick={() => {
        setActiveTab(id);
        analytics.trackButtonClick(`profile_tab_${id}`, 'profile');
      }}
      className={`capitalize px-4 py-2 text-sm font-semibold transition border-b-2 ${activeTab === id ? "text-blue-600 border-blue-600" : "text-gray-500 border-transparent hover:text-blue-600"
      }`}
    >
      {label}
    </button>
  );

  if (!user) return <div className="text-center py-10">Loading profile...</div>;

  return (
    <div className="max-w-6xl mx-auto flex-1 px-6 py-10">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-1">Account Settings</h1>
        <p className="text-gray-600">Manage your profile, billing, and company information.</p>
      </div>

      <div className="flex space-x-4 border-b border-gray-200 mb-6">
        {[
          ["overview", "Overview"],
          ["plan", "Plan & Billing"]
        ].map(([id, label]) => renderTabButton(id, label))}
      </div>

      <div className="bg-white shadow-md rounded-xl p-8 space-y-6">
        {activeTab === "overview" && (
          <>
            <h2 className="text-xl font-bold mb-4">Personal Information</h2>
            {renderRow(<FaUser />, "Full Name", `${user.firstName} ${user.lastName}`)}
            {renderRow(<FaEnvelope />, "Email", user.email)}
            {renderRow(<FaShieldAlt />, "Sign-In Method", "Email & Password")}
            
            <div className="border-t pt-6 mt-6">
              <h2 className="text-xl font-bold mb-4">Company Information</h2>
              {renderRow(<FaBuilding />, "Company Name", user.companyName)}
              {renderRow(<FaListAlt />, "Tax / Fiscal Number", user.fiscalNumber)}
            </div>
          </>
        )}

        {activeTab === "plan" && (
          <>
            <h2 className="text-xl font-bold mb-4">Subscription & Billing</h2>
            <SubscriptionManager 
              onSubscriptionChange={(subscription) => {
                // Update local storage with new subscription data
                if (subscription) {
                  localStorage.setItem("plan_status", JSON.stringify({
                    plan: subscription.plan,
                    status: subscription.status,
                    credits: subscription.credits,
                    end_date: subscription.end_date,
                    limit_date: subscription.limit_date
                  }));
                }
              }}
            />
          </>
        )}


      </div>
    </div>
  );
};

export default Profile;
